import { render } from "./HomeTabs.vue?vue&type=template&id=4a2367eb"
import script from "./HomeTabs.vue?vue&type=script&lang=js"
export * from "./HomeTabs.vue?vue&type=script&lang=js"

import "./HomeTabs.vue?vue&type=style&index=0&id=4a2367eb&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__